const mutations = {
	['UPDATE_APP_BASE_INFO'] (state, payload) {
		state.appid = payload.appid;
	},
};

export default mutations;